import { Box, Typography, Link, Grid, IconButton } from "@mui/material";
import { Instagram, YouTube, WhatsApp } from "@mui/icons-material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  return (
    <footer>
      <Box
        sx={{
          bgcolor: "primary.main",
          pt: { xs: 5, md: 7 },
          pb: { xs: 1 },
          px: { xs: 2, md: 8 },
          borderTop: "3px solid",
          borderColor: "primary.dark",
          boxShadow: "0 -4px 24px rgba(20,84,68,0.10)",
          maxWidth: "100vw",
          overflow: "hidden",
        }}
      >
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{ flexWrap: "wrap", rowGap: 3 }}
        >
          {/* Colonna Sinistra - Mini Bio */}
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ textAlign: { xs: "center", sm: "left" } }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.2,
                alignItems: { xs: "center", sm: "flex-start" },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontFamily: "PlayfairDisplay-Regular, serif",
                  mb: 1,
                  fontWeight: 600,
                  letterSpacing: ".02em",
                }}
              >
                Chi sono
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontFamily: "PlayfairDisplay-Regular, serif",
                  opacity: 0.85,
                  maxWidth: 320,
                }}
              >
                Mi chiamo Ilaria Stumpo e sono un’appassionata insegnante di
                yoga e coach del benessere, costantemente impegnata in un
                processo di continua crescita personale e professionale.
              </Typography>
            </Box>
          </Grid>

          {/* Colonna Centrale - Contatti */}
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ textAlign: { xs: "center", sm: "left" } }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                alignItems: { xs: "center", sm: "flex-start" },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontFamily: "PlayfairDisplay-Regular, serif",
                  mb: 1,
                  fontWeight: 600,
                  letterSpacing: ".02em",
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                Contatti
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
              >
                <IconButton
                  sx={{
                    color: "white",
                    bgcolor: "primary.dark",
                    "&:hover": {
                      bgcolor: "secondary.main",
                      color: "primary.main",
                    },
                  }}
                  aria-label="Chiama il numero"
                  href="tel:+393463721890"
                >
                  <LocalPhoneIcon />
                </IconButton>
                <Link
                  href="tel:+393463721890"
                  underline="hover"
                  color={"white"}
                  sx={{
                    fontFamily: "PlayfairDisplay-Regular, serif",
                    fontWeight: 500,
                  }}
                >
                  +39 346 3721890
                </Link>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
              >
                <IconButton
                  sx={{
                    color: "white",
                    bgcolor: "primary.dark",
                    "&:hover": {
                      bgcolor: "secondary.main",
                      color: "primary.main",
                    },
                  }}
                  aria-label="Scrivi una mail"
                  href="mailto:ilariastumpo.coaching@gmail.com"
                >
                  <EmailIcon />
                </IconButton>
                <Link
                  href="mailto:ilariastumpo.coaching@gmail.com"
                  underline="hover"
                  color={"white"}
                  sx={{
                    fontFamily: "PlayfairDisplay-Regular, serif",
                    fontWeight: 500,
                  }}
                >
                  ilariastumpo.coaching@gmail.com
                </Link>
              </Box>
            </Box>
          </Grid>

          {/* Colonna Destra - Social Media */}
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ textAlign: { xs: "center", sm: "left" } }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", sm: "flex-start" },
                mt: { xs: 2, sm: 0 },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontFamily: "PlayfairDisplay-Regular, serif",
                  mb: 1,
                  fontWeight: 600,
                  letterSpacing: ".02em",
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                Social
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  justifyContent: { xs: "center", sm: "flex-start" },
                  alignItems: "center",
                }}
              >
                <IconButton
                  className="footer-social"
                  sx={{
                    color: "white",
                    bgcolor: "primary.dark",
                    mx: 0.2,
                    fontSize: { xs: 28, sm: 22 },
                    transition: "transform 0.18s",
                    "&:hover": {
                      bgcolor: "secondary.main",
                      color: "primary.main",
                      transform: "scale(1.13) rotate(-8deg)",
                    },
                  }}
                  href="https://www.instagram.com/ilariastumpo_yogaecoaching/"
                  target="_blank"
                  aria-label="Instagram"
                >
                  <Instagram className="footer-social-icon" />
                </IconButton>
                <IconButton
                  className="footer-social"
                  sx={{
                    color: "white",
                    bgcolor: "primary.dark",
                    mx: 0.2,
                    fontSize: { xs: 28, sm: 22 },
                    transition: "transform 0.18s",
                    "&:hover": {
                      bgcolor: "secondary.main",
                      color: "primary.main",
                      transform: "scale(1.13) rotate(8deg)",
                    },
                  }}
                  href="https://wa.me/+393463721890"
                  target="_blank"
                  aria-label="WhatsApp"
                >
                  <WhatsApp className="footer-social-icon" />
                </IconButton>
                <IconButton
                  className="footer-social"
                  sx={{
                    color: "white",
                    bgcolor: "primary.dark",
                    mx: 0.2,
                    fontSize: { xs: 28, sm: 22 },
                    transition: "transform 0.18s",
                    "&:hover": {
                      bgcolor: "secondary.main",
                      color: "primary.main",
                      transform: "scale(1.13) rotate(-8deg)",
                    },
                  }}
                  href="https://www.youtube.com/@ilariastumpo"
                  target="_blank"
                  aria-label="YouTube"
                >
                  <YouTube className="footer-social-icon" />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Typography
          variant="body2"
          component="p"
          color={"white"}
          textAlign={"center"}
          pt={4}
          sx={{
            opacity: 0.85,
            fontWeight: 400,
            fontSize: "1.05rem",
            fontFamily: "PlayfairDisplay-Regular, serif",
            letterSpacing: ".01em",
          }}
        >
          © 2025 Ilaria Stumpo. Tutti i diritti riservati.
        </Typography>
      </Box>
    </footer>
  );
};

export default Footer;
